/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import BizCard from '../../components/UI/BizCard';
import LdsFisView from './LdsFisView';
import { currencyFormat, amountUnitDetails, leadFinancialSummaryNames } from '../../utils/globals';

const proposalTypes = {
  greenfield: 'Greenfield',
  brownfieldNew: 'Brownfield - New',
  brownfieldExpansion: 'Brownfield - Expansion',
};

const LeadDataSheet = (props) => {
  let totalExistingBankers = 0;
  props.leadDataSheet.existingBankers.forEach((entry) => {
    totalExistingBankers += entry.tl + entry.cc + entry.bg + entry.lc + entry.other;
  });

  return (
    <div>
      <BizCard title="Lead Data Sheet">
        <table className="biz-form-table">
          <tbody>
            <tr>
              <td className="biz-form-table-label">Name of the Lead</td>
              <td className="biz-form-table-input">{props.leadDataSheet.name}</td>
            </tr>

            <tr>
              <td className="biz-form-table-label">Constitution</td>
              <td className="biz-form-table-input">{props.leadDataSheet.constitution}</td>
            </tr>

            {/* Sector */}
            <tr>
              <td className="biz-form-table-label">Sectors</td>
              <td className="biz-form-table-input">
                {
                  props.leadDataSheet.sectors.map((sector) => (<p key={sector}>{sector}</p>))
                }
              </td>
            </tr>

            {/* Activity */}
            <tr>
              <td className="biz-form-table-label">Activity</td>
              <td className="biz-form-table-input">
                {
                  props.leadDataSheet.activities.map((entry) => (<p key={entry}>{entry}</p>))
                }
              </td>
            </tr>

            {/* Group name */}
            <tr>
              <td className="biz-form-table-label">Group Name</td>
              <td className="biz-form-table-input">{props.leadDataSheet.groupName}</td>
            </tr>

            {/* Segment */}
            <tr>
              <td className="biz-form-table-label">Segment</td>
              <td className="biz-form-table-input">{props.leadDataSheet.segment}</td>
            </tr>

            {/* Processing location */}
            <tr>
              <td className="biz-form-table-label">Processing Location</td>
              <td className="biz-form-table-input">{props.leadDataSheet.processingLocation}</td>
            </tr>

            {/* Proposal Type */}
            <tr>
              <td className="biz-form-table-label">Proposal Type</td>
              <td className="biz-form-table-input">{proposalTypes[props.leadDataSheet.proposalType]}</td>
            </tr>

            {/* Addresses */}
            <tr>
              <td className="biz-form-table-label">Address</td>
              <td className="biz-form-table-input">
                {
                  props.leadDataSheet.addresses.length > 0 ?
                    <table className="biz-data-table biz-bordered">
                      <thead>
                        <tr>
                          <th>Type</th>
                          <th>Street address</th>
                          <th>City</th>
                          <th>State</th>
                          <th>Pincode</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          props.leadDataSheet.addresses.map((address) => (
                            <tr key={address.id}>
                              <td>{address.type}</td>
                              <td>
                                <span dangerouslySetInnerHTML={{ __html: address.address.replace(/\r?\n|\r/g, '<br />') }} />
                              </td>
                              <td>{address.city}</td>
                              <td>{address.state}</td>
                              <td>{address.pincode}</td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                    :
                    null
                }
              </td>
            </tr>

            {/* Name of promoters */}
            <tr>
              <td className="biz-form-table-label">Promoters</td>
              <td className="biz-form-table-input">
                {
                  props.leadDataSheet.promoters.length > 0 ?
                    <table className="biz-data-table biz-bordered">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>PAN</th>
                          <th>DOB</th>
                          <th>Address</th>
                          <th>Networth</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          props.leadDataSheet.promoters.map((entry) => (
                            <tr key={entry.id}>
                              <td>{`${entry.firstName} ${entry.middleName} ${entry.lastName}`}</td>
                              <td>{entry.pan}</td>
                              <td>{entry.dob}</td>
                              <td>
                                <span dangerouslySetInnerHTML={{ __html: entry.streetAddress.replace(/\r?\n|\r/g, '<br />') }} />
                                <br />
                                {entry.city}. {entry.state} - {entry.pincode}
                              </td>
                              <td>{entry.networth}</td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                    :
                    null
                }
              </td>
            </tr>

            {/* Existing External Ratings */}
            <tr>
              <td className="biz-form-table-label">Existing External Ratings</td>
              <td className="biz-form-table-input">
                {
                  props.leadDataSheet.externalRatings.length > 0 ?
                    <table className="biz-data-table biz-bordered" style={{ width: 300 }}>
                      <thead>
                        <tr>
                          <th>Agency</th>
                          <th>Rating</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          props.leadDataSheet.externalRatings.map((entry) => (
                            <tr key={entry.id}>
                              <td>{entry.agency}</td>
                              <td>{entry.rating}</td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                    :
                    null
                }
              </td>
            </tr>

            {/* Exposure Chart */}
            <tr>
              <td className="biz-form-table-label">Exposure Chart</td>
              <td className="biz-form-table-input">
                {
                  props.leadDataSheet.existingBankers.length > 0 ?
                    <table className="biz-data-table biz-bordered">
                      <thead>
                        <tr>
                          <th>Bank</th>
                          <th>CC</th>
                          <th>TL</th>
                          <th>LC</th>
                          <th>BG</th>
                          <th>Other</th>
                          <th>Total</th>
                          <th>% share</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          props.leadDataSheet.existingBankers.map((pb) => (
                            <tr key={pb.id}>
                              <td>{pb.bankName}</td>
                              <td>{currencyFormat(pb.cc)} {amountUnitDetails[props.leadDataSheet.amountUnit].symbol}</td>
                              <td>{currencyFormat(pb.tl)} {amountUnitDetails[props.leadDataSheet.amountUnit].symbol}</td>
                              <td>{currencyFormat(pb.lc)} {amountUnitDetails[props.leadDataSheet.amountUnit].symbol}</td>
                              <td>{currencyFormat(pb.bg)} {amountUnitDetails[props.leadDataSheet.amountUnit].symbol}</td>
                              <td>{currencyFormat(pb.other)} {amountUnitDetails[props.leadDataSheet.amountUnit].symbol}</td>
                              <td>
                                {currencyFormat(pb.tl + pb.cc + pb.bg + pb.lc + pb.other)} {amountUnitDetails[props.leadDataSheet.amountUnit].symbol}
                              </td>
                              <td>
                                {(((pb.tl + pb.cc + pb.bg + pb.lc + pb.other) / totalExistingBankers) * 100).toFixed(2)}
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                    :
                    null
                }
              </td>
            </tr>

            {/* Current Proposal */}
            <tr>
              <td className="biz-form-table-label">Current Proposal</td>
              <td className="biz-form-table-input">
                {
                  props.leadDataSheet.currentProposal.length > 0 ?
                    <table className="biz-data-table biz-bordered">
                      <thead>
                        <tr>
                          <th>Remark</th>
                          <th>CC</th>
                          <th>TL</th>
                          <th>LC</th>
                          <th>BG</th>
                          <th>Other</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          props.leadDataSheet.currentProposal.map((cp) => (
                            <tr key={cp.id}>
                              <td>{currencyFormat(cp.remark)}</td>
                              <td>{currencyFormat(cp.cc)} {amountUnitDetails[props.leadDataSheet.amountUnit].symbol}</td>
                              <td>{currencyFormat(cp.tl)} {amountUnitDetails[props.leadDataSheet.amountUnit].symbol}</td>
                              <td>{currencyFormat(cp.lc)} {amountUnitDetails[props.leadDataSheet.amountUnit].symbol}</td>
                              <td>{currencyFormat(cp.bg)} {amountUnitDetails[props.leadDataSheet.amountUnit].symbol}</td>
                              <td>{currencyFormat(cp.other)} {amountUnitDetails[props.leadDataSheet.amountUnit].symbol}</td>
                              <td>
                                {currencyFormat(cp.tl + cp.cc + cp.bg + cp.lc + cp.other)} {amountUnitDetails[props.leadDataSheet.amountUnit].symbol}
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                    :
                    null
                }
              </td>
            </tr>

            {/* Proposal Brief */}
            <tr>
              <td className="biz-form-table-label">Proposal Brief</td>
              <td className="biz-form-table-input">
                <span dangerouslySetInnerHTML={{ __html: props.leadDataSheet.proposalBrief.replace(/\r?\n|\r/g, '<br />') }} />
              </td>
            </tr>

            {/* Financial Summary */}
            <tr>
              <td className="biz-form-table-label">Financial Summary</td>
              <td className="biz-form-table-input">
                <table className="biz-data-table biz-bordered">
                  <thead>
                    <tr>
                      <th>Particulars</th>
                      <th>Mar-{props.leadDataSheet.financialSummaryYears[0]}</th>
                      <th>Mar-{props.leadDataSheet.financialSummaryYears[1]}</th>
                      <th>Mar-{props.leadDataSheet.financialSummaryYears[2]}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      Object.keys(leadFinancialSummaryNames).map((key) => (
                        <tr key={key}>
                          <td>{leadFinancialSummaryNames[key]}</td>
                          <td>{props.leadDataSheet.financialSummary[key][0]}</td>
                          <td>{props.leadDataSheet.financialSummary[key][1]}</td>
                          <td>{props.leadDataSheet.financialSummary[key][2]}</td>
                        </tr>
                      ))
                    }
                  </tbody>
                </table>
              </td>
            </tr>

            {/* Landline */}
            <tr>
              <td className="biz-form-table-label">Landline no.</td>
              <td className="biz-form-table-input">{props.leadDataSheet.landline}</td>
            </tr>

            {/* Email */}
            <tr>
              <td className="biz-form-table-label">Company email id</td>
              <td className="biz-form-table-input">{props.leadDataSheet.companyEmail}</td>
            </tr>

            {/* Website */}
            <tr>
              <td className="biz-form-table-label">Website</td>
              <td className="biz-form-table-input">{props.leadDataSheet.website}</td>
            </tr>
          </tbody>
        </table>
      </BizCard>

      {
        props.fis ?
          <LdsFisView fis={props.fis} />
          :
          null
      }
    </div>
  );
};

LeadDataSheet.propTypes = {
  leadDataSheet: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  fis: PropTypes.shape({
    id: PropTypes.number,
  }),
};

LeadDataSheet.defaultProps = {
  fis: null,
};

export default LeadDataSheet;



// WEBPACK FOOTER //
// ./src/pages/leads/LeadDataSheet.jsx